
import { Component, Mixins } from "vue-property-decorator";
import { StandardOption, OptionSelectableMixin } from ".";

@Component({
})
export default class SingleOptionSelectableMixin extends Mixins(OptionSelectableMixin) {
  get selectedOption(): StandardOption<any> {
    return this.findOption(this.editingSource, this.options);
  }

  set selectedOption(option: StandardOption<any>) {
    this.editingSource = option
      ? option.value
      : null;
  }
}
